import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CtaProps, ImageCard } from '../../../atoms';
import { CHECKOUT_URLS } from '../../../config';
import { useHormones, useMe } from '../../../config/api/queries';

export const CortisolResultsCard = ({
  scrollToOrderTracking,
}: {
  scrollToOrderTracking?: () => void;
}): JSX.Element => {
  const me = useMe();
  const hormoneReport = useHormones();
  const navigate = useNavigate();

  const cortisolStates: { [name: string]: CtaProps } = {
    results_available: {
      btnId: 'cortisol-results',
      text: 'View full report',
      func: () => navigate('/dashboard/cortisol-report'),
      subText: `Order cortisol test`,
      subTextLink: CHECKOUT_URLS.cortisol_test.link,
    },
    // TODO - can bring back if new blood tests are added
    // ordered: {
    //   btnId: 'cortisol-track-order',
    //   text: 'Track Order',
    //   subText: 'We got your order!',
    //   func: () =>
    //     scrollToOrderTracking
    //       ? scrollToOrderTracking()
    //       : navigate('/dashboard'),
    // },
    // needs_order: {
    //   btnId: 'cortisol-report-order',
    //   subText: 'Results within 2 weeks',
    //   text: 'Order cortisol test',
    //   link: CHECKOUT_URLS.cortisol_subscription.link,
    // },
  };

  const [cortisolState, setCortisolState] = useState<CtaProps>();

  useEffect(() => {
    if (hormoneReport.data && hormoneReport.data?.length > 0) {
      setCortisolState(cortisolStates.results_available);
      return;
    }
  }, [hormoneReport.data, me.data]);

  return (
    <>
      <ImageCard
        image="/images/sunrise.jpeg"
        alttext="image of sunrise"
        variant="halfImage"
        title="Cortisol Report"
        description="Easily test your cortisol levels 3 times throughout the day to learn how your body responds to stress."
        cta={cortisolState}
      />
    </>
  );
};
